// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kt-0";
export var fileCarousel = "_kt-2";
export var removeFileButton = "_kt-1";